import { jsx } from 'react/jsx-runtime';
import { styled } from '@flex-design-system/stitches-react';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { FormFieldFieldBox } from './components/field-box/FieldBox.mjs';
import { FormFieldHelperText } from './components/helper-text/HelperText.mjs';
import { FormFieldLabel } from './components/label/Label.mjs';
import { FormFieldPlaceholder } from './components/placeholder/Placeholder.mjs';
import { FormFieldContextProvider } from './context.mjs';
import { formField } from './formField.vanilla.mjs';

const FormFieldImpl = forwardRef(
  ({ className: classNameFromProps, disabled, required, state, ...props }, forwardedRef) => {
    const className = classNames(formField, classNameFromProps);
    return /* @__PURE__ */ jsx(
      FormFieldContextProvider,
      {
        disabled,
        required,
        state,
        children: /* @__PURE__ */ jsx(
          StyledDiv,
          {
            "data-scope": "form-field",
            "data-part": "root",
            className,
            ref: forwardedRef,
            ...props
          }
        )
      }
    );
  }
);
const StyledDiv = styled("div");
const FormField = Object.assign({}, FormFieldImpl, {
  Label: FormFieldLabel,
  FieldBox: FormFieldFieldBox,
  Placeholder: FormFieldPlaceholder,
  HelperText: FormFieldHelperText
});
FormField.displayName = "FormField";

export { FormField };
//# sourceMappingURL=FormField.mjs.map
